module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "abre"
  }, [_vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('table', {
    staticClass: "table10"
  }, [_c('colgroup', [_c('col', {
    staticClass: "a30"
  }), _vm._v(" "), _c('col', {
    staticClass: "a70"
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AMPRONAC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Asociación de Mujeres ante la Problemática Nacional")]), _vm._v(" (Association of Women Confronting the National Problem)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BECAT")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Brigadas Especiales Contra Actos Terroristas")]), _vm._v(" (Special Squads Against Terrorist Acts)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CIA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Central Intelligence Agency, United States")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COIN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("counter-insurgent or counter-insurgency")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONDECA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Consejo de Defensa Centroamericana")]), _vm._v(" (Central American Defense Council)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EDSN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ejercito Defensor de la Soberania Nacional")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EEBI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Escuela Entrenamiento Básico De Infantería")]), _vm._v(" (Infantry Basic Training School)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FAL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fusil Automatique Léger")]), _vm._v(" (light automatic rifle, Belgian-designed firearm)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FAN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fuerza Aérea Nicaragüense")]), _vm._v(" (Nicaraguan Air Force)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FAO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frente Amplio Opositor")]), _vm._v(" (Broad Opposition Front)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FAS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fuerza Aérea Sandinista")]), _vm._v(" (Sandinista Air Force)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FER")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frente Estudiantil Revolucionarío")]), _vm._v(" (Revolutionary Student Front)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FPN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frente Patriotico Nacional")]), _vm._v(" (National Patriotic Front)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FSLN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frente Sandinista de Liberación Nacional")]), _vm._v(" (Sandinista National Liberation Front)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Guardia Nacional")]), _vm._v(" (National Guard)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GPP")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Guerra Popular Prolongada (Prolonged Popular War)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JGRN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Junta de Gobierno de Reconstrucción Nacional")]), _vm._v(" (Junta of National Reconstruction)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LAAHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Latin American Aviation History Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MNA")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Movimiento Nueva Nicaragua")]), _vm._v(" (New Nicaragua Movement)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MPS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Milicia Popular Sandinista")]), _vm._v(" (Sandinista Popular Militia)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MPU")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Movimiento Pueblo Unido (United People’s Movement)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OAS")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Organization of American States")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("OSN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oficina de Seguridad Nacional")]), _vm._v(" (National Security Office)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PLI")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Partido Liberal Indepediente")]), _vm._v(" (Independent Liberal Party)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PLN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Partido Liberal Nacionalista")]), _vm._v(" (Liberal Nationalist Party)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PSN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Partido socialista nicaragüense")]), _vm._v(" (Nicaraguan Socialist Party)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RPG")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Rocket-propelled grenade")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Servicio Anticomunista")]), _vm._v(" (Anti-Communist Service)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TCU")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Tactical Combat Units")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("UDEL")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unión Democrática de Liberación ")]), _vm._v("(Democratic Liberation Union)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("UN")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("United Nations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("UNO")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unión Nacional Opositora")]), _vm._v(" (National Opposition Union)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USMC")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("United States Marine Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("US$")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("United States Dollar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Union of Soviet Socialist Republics (or ‘Soviet Union’)")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4ee150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Abbreviation.vue
// module id = 66
// module chunks = 0